document.addEventListener('DOMContentLoaded', function() {
  const searchButton = document.querySelector('.js-open-search');
  const searchInput = document.querySelector('.js-predictive-search-input');
  
  if (searchButton && searchInput) {
    searchButton.addEventListener('click', () => {
      searchInput.focus();
      searchInput.dispatchEvent(new Event('focus'));
    });
  }
});

/* ==========================================================
   JAKOB: INVENTORY-TEXT FIX — "Slutsålt" → "Tillfälligt slut"
   ========================================================== */

document.addEventListener("DOMContentLoaded", function() {

  function replaceSoldOutText() {
    const containers = document.querySelectorAll('#inventory-info-app, .iia-container');
    containers.forEach(container => {
      const elements = container.querySelectorAll('*');
      elements.forEach(el => {
        const text = el.textContent.trim();
        if (text === 'Slutsålt') {
          el.textContent = 'Tillfälligt slut';
        }
      });
    });
  }
});



/* ==========================================================
   JAKOB: Gradient för inspirations "läs mer"
   ========================================================== */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".page-description--truncate").forEach(function (el) {
    if (el.scrollHeight > el.clientHeight + 10) {
      el.classList.add("truncate--overflow");
    }
  });
});


